module.exports = __webpack_public_path__ + "img/Safety.7906c918.svg";